const VERY_SLOW_CONNECTIONS = new Set(['slow-2g', '2g']);

export const getStoryFrameLoadingProfile = (connection, compactViewport = false) => {
  const effectiveType = String(connection?.effectiveType || '').toLowerCase();

  if (compactViewport) {
    return {
      initialFrameCount: 0,
      highPriorityFrameCount: 0,
      preloadRemaining: false,
      batchSize: 0,
      batchDelayMs: 0,
      lookaheadFrameCount: 6,
      lookbackFrameCount: 4,
      maxPendingFrameCount: 12,
      maxSmoothFrameLag: 24,
    };
  }

  if (connection?.saveData || VERY_SLOW_CONNECTIONS.has(effectiveType)) {
    return {
      initialFrameCount: 10,
      highPriorityFrameCount: 3,
      preloadRemaining: false,
      batchSize: 0,
      batchDelayMs: 0,
      lookaheadFrameCount: 8,
      lookbackFrameCount: 4,
      maxPendingFrameCount: 12,
      maxSmoothFrameLag: Infinity,
    };
  }

  if (effectiveType === '3g') {
    return {
      initialFrameCount: 18,
      highPriorityFrameCount: 4,
      preloadRemaining: true,
      batchSize: 4,
      batchDelayMs: 320,
      lookaheadFrameCount: 12,
      lookbackFrameCount: 6,
      maxPendingFrameCount: Infinity,
      maxSmoothFrameLag: Infinity,
    };
  }

  return {
    initialFrameCount: 28,
    highPriorityFrameCount: 6,
    preloadRemaining: true,
    batchSize: 8,
    batchDelayMs: 180,
    lookaheadFrameCount: 18,
    lookbackFrameCount: 8,
    maxPendingFrameCount: Infinity,
    maxSmoothFrameLag: Infinity,
  };
};
